import { styled } from '@mui/material/styles';

import colors from 'themes/colors';

const STATUS_COLOR_CODE = {
  PENDING: colors.orangeTwo,
  IN_PROGRESS: colors.lightOrange,
  COMPLETED: colors.green,
  SUCCEEDED: colors.green,
  FAILED: colors.red,
  LATE: colors.periwinkleFifth,
  EARLY: colors.darkBlue,
};

export const Container = styled('div')({
  boxSizing: 'border-box',
  borderRadius: '3px',
  lineHeight: '1.5em',
  fontSize: '15px',
  boxShadow: '0px 0px 1px #888',
  minHeight: '44px',
  margin: '10px 1px',
  overflow: 'hidden',
  cursor: 'pointer',
  position: 'relative',
  textAlign: 'left',
  borderRight: 'solid 6px',
  borderRightColor: STATUS_COLOR_CODE.PENDING,
});

export const Inner = styled('div')({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '6px',
  padding: '10px 4px 7px 4px',
  backgroundColor: 'white',
});

export const ContainerTag = styled('div')({
  padding: '7px 15px',
  borderTop: 'solid 1px #eaeaea',
  backgroundColor: '#f2f3f2',
});

export const Row = styled('div')({
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'row',
});

export const Col = styled('div')({
  flex: 1,
});

export const Logo = styled('div')({
  width: '32px',
  height: '32px',
});

export const Text = styled('div')({
  fontFamily: 'AvenirNext',
  fontWeight: 600,
  fontSize: '12px',
  textAlign: 'left',
  color: '#3b3b3b',

  '&.text-right': {
    textAlign: 'right',
  },
  '&.text-center': {
    textAlign: 'center',
  },
  '&.text-left': {
    textAlign: 'left',
  },
});

export const SmallText = styled('span')({
  fontFamily: 'AvenirNext',
  fontWeight: 600,
  fontSize: '9px',
  color: '#3b3b3b',
  display: 'inline-block',
});

export const DayText = styled('span')({
  color: '#55a',
});

export const TimeZoneText = styled('span')({
  fontFamily: 'AvenirNext',
  fontWeight: 900,
});

export const Name = styled('div')({
  fontFamily: 'AvenirNext',
  fontSize: '14px',
  fontWeight: 900,
  color: '#3b3b3b',
});

export const RibbonDeleted = styled('div')((props) => ({
  position: 'absolute',
  top: '0px',
  right: '10px',
  bottom: '0px',
  margin: 'auto',
  fontSize: '8px',
  color: 'red',
  padding: '0px 8px',
  transform: props?.isReturnNotAttempted ? 'rotate(15deg)' : 'rotate(45deg)',
  border: '1px solid red',
  borderRadius: '1px',
  height: '22px',
}));

export const correctedStyle = {
  fontFamily: 'AvenirNext',
  fontWeight: 600,
  fontSize: '12px',
  textAlign: 'right',
  color: '#3b3b3b',
};

export default {
  statuses: {
    PENDING: {
      borderRightColor: STATUS_COLOR_CODE.PENDING,
    },
    IN_PROGRESS: {
      borderRightColor: STATUS_COLOR_CODE.IN_PROGRESS,
    },
    SUCCEEDED: {
      borderRightColor: STATUS_COLOR_CODE.SUCCEEDED,
    },
    FAILED: {
      borderRightColor: STATUS_COLOR_CODE.FAILED,
    },
    DROP_OFF: {
      PENDING: {
        borderRightColor: STATUS_COLOR_CODE.PENDING,
      },
      IN_PROGRESS: {
        borderRightColor: STATUS_COLOR_CODE.IN_PROGRESS,
      },
      SUCCEEDED: {
        borderRightColor: STATUS_COLOR_CODE.SUCCEEDED,
      },
      FAILED: {
        borderRightColor: STATUS_COLOR_CODE.FAILED,
      },
      DISCARDED: {
        borderRightColor: '#aaa',
      },
    },
    RETURN: {
      PENDING: {
        borderRightColor: colors.grayThird,
      },
      IN_PROGRESS: {
        borderRightColor: colors.grayThird,
      },
      SUCCEEDED: {
        borderRightColor: colors.bluish,
      },
      FAILED: {
        borderRightColor: '#222',
      },
      DISCARDED: {
        borderRightColor: '#aaa',
      },
    },
  },
};
